import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from '../../components/ui';
import { AuthProvider } from './AuthProvider';
import type { ReactNode } from 'react';

/** Everything the app needs around it: routing, toasts and the signed-in user. */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>{children}</AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
